export default "__VITE_ASSET__CS8c7tml__"